import { render, staticRenderFns } from "./LogoList.vue?vue&type=template&id=28707d03&"
import script from "./LogoList.vue?vue&type=script&lang=js&"
export * from "./LogoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports